import { createSignedRequest } from 'utils/createSignedRequest';
import Config from 'Config';
import axios from 'axios';

export const getFilledCustomFormsService = async () => {
  const apiPath = 'form-editor/filled-forms';
  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);

  const response = await fetch(signedRequest.url, {
    method: signedRequest.method,
    headers: signedRequest.headers,
  });

  return await response.json();
};

export const createFilledCustomFormsService = async (filledForm) => {
  const apiPath = 'form-editor/filled-forms';
  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ filledCustomForm: filledForm }),
    data: { filledCustomForm: filledForm },
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};

export const deleteFilledCustomFormsService = async (filledForm, projectId) => {
  const apiPath = `form-editor/${projectId}/filled-forms/${filledForm.id}`;
  const body = { id: filledForm.id, projectId };
  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'DELETE',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    data: body,
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};

export const getInputDataWithMediaUrlService = async (inputData, s3Key) => {
  const apiPath = 'form-editor/filled-forms/input-image';
  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ inputData, s3Key }),
    data: { inputData, s3Key },
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};
